<template>
  <div class="shell-page">
    <HeaderMain @messageFromHeader="searchEvents" />

    <div v-if="requestUserStatus === false || requestUserStatus === 'false'">
      <DisabledAccount />
    </div>

    <div v-else>
      <SlideShow :main="title" :subtitle="subtitle" type="1" :active-events-count="activeEventsCount" />
      <SearchCourse v-if="!main" :courses="search" />

      <div v-if="err" class="shell-empty-state">
        No encontramos resultados con esa búsqueda. Prueba otro artista, venue o experiencia.
      </div>

      <section id="agenda-activa" class="shell-section home-agenda-intro">
        <div class="section-heading">
          <span class="section-heading__eyebrow">En agenda ahora</span>
          <h2 class="section-heading__title">Lo que se mueve hoy en FOMO</h2>
          <p class="section-heading__text">
            Entra directo a los eventos activos y decide rápido.
          </p>
        </div>
      </section>

      <EventCard v-show="main" show="next" order="asc" :page-size="9" :show-empty-state="false" :infinite="true" @events-count-updated="setActiveEventsCount" />

      <section v-if="main" id="agenda-archivo" class="shell-section home-agenda-intro home-agenda-intro--archive">
        <div class="section-heading">
          <h2 class="section-heading__title">Fechas pasadas</h2>
        </div>
      </section>

      <EventCard
        v-if="main"
        show="prev"
        order="attendance"
        :page-size="9"
        :infinite="true"
        card-mode="archive"
        :interactive="false"
        empty-state-copy="Todavía no tenemos archivo publicado de eventos pasados."
      />

      <EventCard v-if="!main" :eventsProp="search" />
      <FooterMain />
    </div>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import SlideShow from '@/components/SlideShow.vue'
import SearchCourse from '@/components/SearchCourse.vue'
import DisabledAccount from '@/components/DisabledAccount.vue'
import FooterMain from '@/components/FooterMain.vue'
import EventCard from '@/components/EventCard.vue'

export default {
  name: 'HomeMain',

  components: {
    HeaderMain,
    SlideShow,
    SearchCourse,
    DisabledAccount,
    FooterMain,
    EventCard,
  },

  data() {
    return {
      activeEventsCount: null,
      search: [],
      searchField: '',
      main: true,
      err: false,
      requestUserStatus: false,
      requestUserType: false,
      subtitle: 'Entradas, listas y experiencias curadas en un solo lugar.',
      title: 'Hay dos clases de planes',
    }
  },

  methods: {
    searchEvents(results, term) {
      this.search = results
      this.searchField = term

      if (this.searchField !== '') {
        if (this.search.length !== 0) {
          this.main = false
          this.err = false
        } else {
          this.main = true
          this.err = true
        }
      } else {
        this.main = true
        this.err = false
      }
    },

    setUserData() {
      this.requestUserStatus = window.localStorage.getItem('is_active')
      this.requestUserType = window.localStorage.getItem('is_gold')
    },

    setActiveEventsCount(count) {
      this.activeEventsCount = count
    },
  },

  created() {
    this.setUserData()
  },
}
</script>

<style scoped>
.home-agenda-intro {
  padding-top: 26px;
  padding-bottom: 24px;
}

.home-agenda-intro--archive {
  padding-top: 38px;
}

@media (max-width: 720px) {
  .home-agenda-intro {
    padding-top: 10px;
    padding-bottom: 12px;
  }

  .home-agenda-intro--archive {
    padding-top: 22px;
  }

  .home-agenda-intro .section-heading {
    gap: 6px;
    margin-bottom: 10px !important;
  }

  .home-agenda-intro .section-heading__title {
    max-width: 14ch;
    font-size: clamp(1.45rem, 7vw, 1.95rem) !important;
    line-height: 0.98 !important;
  }

  .home-agenda-intro .section-heading__text {
    max-width: 30ch;
    font-size: 0.82rem !important;
    line-height: 1.35 !important;
  }
}
</style>
